import { t } from '@lingui/macro'
import styled from 'styled-components'

import { breakpoints } from '@/config/layout'
import { useGetHomeShortcuts } from '@/modules/home/hooks/useGetHomeShortcuts'
import { HomeSectionLayout } from '../HomeSectionLayout'
import { ShortcutCard } from './shortcut-card/ShortcutCard'

export const ShortcutGridSection = () => {
  const shortcutItems = useGetHomeShortcuts()

  return (
    <HomeSectionLayout
      title={t({
        id: 'home.action-grid-section.title',
        message: 'Maak hieronder je keuze',
      })}
    >
      <StGrid>
        {shortcutItems.map((shortcutItem, index) => (
          <ShortcutCard key={index} shortcutItem={shortcutItem} />
        ))}
      </StGrid>
    </HomeSectionLayout>
  )
}

const StGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-auto-rows: 1fr; /* Make all rows the same height */
  gap: ${({ theme }) => theme.UI.SpacingPx.Space4};

  @media ${breakpoints.m} {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  @media ${breakpoints.l} {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
`
